import { useState, type FormEvent } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { AuthCard } from "./AuthCard";
import { useChangePassword, useLogout } from "./session";

const MIN_LENGTH = 12;

export function ChangePasswordPage({ forced }: { forced?: boolean }) {
  const change = useChangePassword();
  const logout = useLogout();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const mismatch = confirm.length > 0 && next !== confirm;

  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (next !== confirm) return;
    change.mutate({ current_password: current, new_password: next });
  };

  return (
    <AuthCard
      title="Change password"
      subtitle={forced ? "You must choose a new password before continuing." : undefined}
      onSubmit={submit}
    >
      <TextField
        label="Current password"
        type="password"
        autoComplete="current-password"
        value={current}
        onChange={(e) => setCurrent(e.target.value)}
        required
      />
      <TextField
        label="New password"
        helperText={`At least ${MIN_LENGTH} characters`}
        type="password"
        autoComplete="new-password"
        slotProps={{ htmlInput: { minLength: MIN_LENGTH } }}
        value={next}
        onChange={(e) => setNext(e.target.value)}
        required
      />
      <TextField
        label="Confirm new password"
        type="password"
        autoComplete="new-password"
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        error={mismatch}
        helperText={mismatch ? "Passwords do not match." : undefined}
        required
      />
      {change.isError && <Alert severity="error">{change.error.message}</Alert>}
      <Stack direction="row" spacing={1}>
        <Button type="submit" variant="contained" disabled={change.isPending || mismatch}>
          Change password
        </Button>
        <Button onClick={() => logout.mutate()}>Sign out</Button>
      </Stack>
    </AuthCard>
  );
}
